import { NgIf } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  OnInit,
  ViewEncapsulation,
} from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { AssetsService } from '@sc/data-access-assets';
import { DossierSandboxService } from '@sc/data-access-state-management';
import { AuthOktaService } from '@sc/feature-auth-okta';
import { FeatureFlippingManagerService } from '@sc/feature-flipping';
import { CustomerRouterService } from '@sc/feature-path-router-system';
import { ButtonComponent, InsurerLogoComponent } from '@sc/ui-components';
import { map, take } from 'rxjs/operators';

@Component({
  selector: 'sc-unauthorized-customer',
  styleUrls: ['./unauthorized.container.scss'],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [NgIf, InsurerLogoComponent, ButtonComponent, TranslateModule],
  template: `
    <main id="sc-container-id" role="main" class="container">
      <sc-insurer-logo></sc-insurer-logo>

      <div class="oups">
        <p>
          {{
            isPassedAppointment
              ? 'Unauthorized.appointmentPassedTitle'
              : ('Unauthorized.useLinkEmail' | translate)
          }}
        </p>
        <p>
          {{
            isPassedAppointment
              ? 'Unauthorized.appointmentPassedLabel'
              : ('Unauthorized.linkProvidesSafeAccess' | translate)
          }}
        </p>
      </div>
      <sc-button
        *ngIf="
          featureFlippService?.isFeatureActivated('b2c-access-open-arrival') &&
          !isPassedAppointment
        "
        (click)="goToOpenArrival()"
        >{{
          'Unauthorized.declarationRedirectButtonLabel' | translate
        }}</sc-button
      >
    </main>
  `,
})
export class UnauthorizedContainer implements OnInit {
  isPassedAppointment = false;

  constructor(
    private readonly route: ActivatedRoute,
    public assetsService: AssetsService,
    public routerService: CustomerRouterService,
    public featureFlippService: FeatureFlippingManagerService,
    private readonly authService: AuthOktaService,
    private readonly dossierSandboxService: DossierSandboxService
  ) {}

  ngOnInit(): void {
    this.route.queryParams
      .pipe(
        map((queries) => {
          switch (queries.reason) {
            case 'appointment-passed':
              this.isPassedAppointment = true;
              break;
            default:
              this.isPassedAppointment = false;
          }
        }),
        take(1)
      )
      .subscribe();
  }

  goToOpenArrival() {
    this.authService.clearDossierNumber();
    this.dossierSandboxService.clearDossier();

    this.routerService.navigateToPageByName('OpenArrival');
  }
}
